import React from 'react';
import imgBuilding from './assets/img-1.png';
import { BsCheckCircleFill, BsLightbulbFill, BsBriefcaseFill } from 'react-icons/bs';
import './style/aboutus.css';

const AboutUsSection = () => {
    return (
        <section id="aboutusSection" className="bg-white py-20">
            <div className="desktop-layout">
                <div className="w-full">
                    <div className="w-full flex">

                        <div className="bg-gray-50 w-[400px] h-[500px] rounded-tr-2xl rounded-br-2xl rounded-tl-none rounded-bl-none flex items-center justify-between pr-4 relative overflow-visible">
                            <div className="w-[150px] flex items-center justify-end">
                                <div
                                    className="text-lg font-bold uppercase text-gray-300 tracking-[1.6rem] pr-[8rem] rotate-180"
                                    style={{ writingMode: 'vertical-lr', textOrientation: 'mixed' }}
                                >
                                    About us
                                </div>
                            </div>
                            <img
                                src={imgBuilding}
                                alt="Modern office building"
                                className="object-cover rounded-3xl border-[0.9rem] border-white max-w-[300px] h-[380px] relative z-20 my-[1.9rem]"
                                style={{ left: '6rem', position: 'relative' }}
                            />
                        </div>


                        <div className="w-3/5 bg-white p-12 flex flex-col justify-center ml-[9rem]">
                            <h2 className="text-4xl font-bold text-gray-800 mb-8 md:text-4xl text-2xl">
                                Join the Founding 500 <br /> Agents
                            </h2>
                            <div className="space-y-4">
                                <div className="flex items-center text-gray-700">
                                    <BsCheckCircleFill className="text-green-500 text-xl mr-4 flex-shrink-0" />
                                    <span className="font-medium">500 Founding Agent Spots</span>
                                </div>
                                <div className="flex items-center text-gray-700">
                                    <BsLightbulbFill className="text-yellow-400 text-xl mr-4 flex-shrink-0" />
                                    <span className="font-medium">100% Mobile-First Tools</span>
                                </div>
                                <div className="flex items-center text-gray-700">
                                    <BsBriefcaseFill className="text-blue-500 text-xl mr-4 flex-shrink-0" />
                                    <span className="font-medium">Lifetime Referral Rewards</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-layout px-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">
                    Join the Founding 500 Agents
                </h2>
                <div className="bg-gray-50  h-[90vh] rounded-tr-2xl rounded-br-2xl rounded-tl-none rounded-bl-none flex items-center justify-between pr-4 relative overflow-visible
                    w-[70vw] max-w-[400px] h-[60vh] max-h-[500px]">

                    <div className="w-[20vw] max-w-[150px] flex items-center justify-end">
                        <div
                            className="text-md font-bold uppercase text-gray-300 tracking-[1.1rem] rotate-180 pr-[1.7rem]"
                            style={{ writingMode: 'vertical-lr', textOrientation: 'mixed' }}
                        >
                            About us
                        </div>
                    </div>

                    <img
                        src={imgBuilding}
                        alt="Modern office building"
                        className="object-cover rounded-3xl border-[0.9rem] border-white max-w-[70vw] max-w-[300px] h-[65vh] max-h-[380px] relative z-20 my-[1.9rem]"
                        style={{ left: '5vw', position: 'relative' }}
                    />
                </div>
                <br></br>
                <div className="space-y-4">
                    <div className="flex items-center text-gray-700">
                        <BsCheckCircleFill className="text-green-500 text-xl mr-4 flex-shrink-0" />
                        <span className="font-medium">500 Founding Agent Spots</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                        <BsLightbulbFill className="text-yellow-400 text-xl mr-4 flex-shrink-0" />
                        <span className="font-medium">100% Mobile-First Tools</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                        <BsBriefcaseFill className="text-blue-500 text-xl mr-4 flex-shrink-0" />
                        <span className="font-medium">Lifetime Referral Rewards</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUsSection;
